import { render, staticRenderFns } from "./GlobalAgentNotification.vue?vue&type=template&id=20fa5e3a&scoped=true&"
import script from "./GlobalAgentNotification.vue?vue&type=script&lang=js&"
export * from "./GlobalAgentNotification.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAgentNotification.vue?vue&type=style&index=0&id=20fa5e3a&scoped=true&lang=scss&"
import style1 from "./GlobalAgentNotification.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fa5e3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBadge,VBtn,VCard,VCheckbox,VDialog,VForm,VIcon,VTextField})
